import React from "react"
import styled, { css } from "styled-components"
import { AppFunctionComponent } from "../../../types"
import CartIcon from "../../commerce/cart-icon/cart-icon.component"
import Avatar from "../user-avatar.component"
import SimpleLanguagePicker from "../simple-language-picker/simple.language-picker.component"
import SearchBox from "../search/search-box"
import EuLogo from "../../../images/icons/eu.svg"
import { Link } from "gatsby"
import useTranslationHook from "../../../hooks/use-translation.hook"

type ControlsProps = {
  isDark?: boolean
}

export const controlStyle = css`
  position: relative;
  margin-left: 10px;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    margin-left: 30px;
    margin-right: 0;
  }
  @media (max-width: 350px) {
    margin-left: 2px;
  }
`

const UserAvatar = styled(Avatar)`
  ${controlStyle}
  padding: 0;
`

const CartControl = styled(CartIcon)`
  ${controlStyle};
`

const SearchBoxControl = styled(SearchBox)`
  ${controlStyle}
  width: 23px;
  height: 23px;
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoint.desktop}px) {
    display: block;
  } ;
`

const LanguageControl = styled(SimpleLanguagePicker)`
  ${controlStyle}
`

const ControlsArea = styled.div`
  position: relative;
  display: flex;
  flex: 2;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  z-index: 2;
`

const StyledEuLogo = styled.img`
  display: block;
  position: absolute;
  top: -45%;
  left: -39%;
  height: 200%;
  @media (min-width: ${({ theme }) => theme.breakpoint.desktop}px) {
    left: 100%;
    height: 220%;
    top: -50%;
  }

  @media (max-width: 350px) {
    left: -45%;
  }
`

const Controls: AppFunctionComponent<ControlsProps> = ({
  children,
  isDark,
}) => {
  const { language } = useTranslationHook()
  return (
    <ControlsArea>
      <>
        <SearchBoxControl isDark={isDark} />
        <span />
        <UserAvatar isDark={isDark} />
        {/* This span is necessary to prevent elements breaking after refresh (MEC-58) */}
        <span />
        <CartControl isDark={isDark} data-testid={"commerce-cart"} />
        <span />
        <LanguageControl />
        {language === "pl" && (
          <Link to="/pl/projekty-ue">
            <StyledEuLogo src={EuLogo} alt="" />
            {/* <EuLogo /> */}
          </Link>
        )}
      </>
      {children}
    </ControlsArea>
  )
}

export default Controls
